import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "hooks/useAuth";

import Status from "pages/Status";

import { Card, CardBody, Box, Heading, Wrap, WrapItem, CardHeader, CardFooter, Button, Alert, AlertIcon, VStack, Text } from "@chakra-ui/react";

import { TbSettingsShare, TbFileUpload, TbExternalLink } from "react-icons/tb";

const Main = (): React.ReactElement => {
  const { user } = useAuth();

  return (
    <Box zIndex={"-1"} p={4}>
      {/* 사용자 정보 표시 */}
      <Box mb={4}>
        <Alert status="info" borderRadius="md">
          <AlertIcon />
          <VStack align="start" spacing={1}>
            <Text fontWeight="bold">환영합니다, {user?.UserName}님!</Text>
            <Text fontSize="sm">그룹: {user?.Groups?.join(", ") || "미지정"}</Text>
          </VStack>
        </Alert>
      </Box>

      <Wrap align={"center"} justify={"center"}>
        <WrapItem>
          <Card>
            <CardHeader>
              <Heading size={"md"}>Job Status</Heading>
            </CardHeader>
            <CardBody minWidth={"1200px"}>
              <Box height={"70vh"} minHeight={"500px"} overflow={"scroll"}>
                <Status size={"card"}></Status>
              </Box>
            </CardBody>
            <CardFooter
              justify="space-between"
              flexWrap="wrap"
              sx={{
                "& > button": {
                  minW: "136px",
                },
              }}
            >
              <Button flex="1" variant="ghost" leftIcon={<TbSettingsShare />} as={Link} to={"/settings"}>
                Settings
              </Button>
              <Button flex="1" variant="ghost" leftIcon={<TbFileUpload />} as={Link} to={"/upload"}>
                Upload
              </Button>
              <Button flex="1" variant="ghost" leftIcon={<TbExternalLink />} as={Link} to={"/status"}>
                Status
              </Button>
            </CardFooter>
          </Card>
        </WrapItem>
      </Wrap>
    </Box>
  );
};

export default Main;
